import { render, staticRenderFns } from "./CollaboratorPriceTableList.vue?vue&type=template&id=69064958&"
import script from "./CollaboratorPriceTableList.vue?vue&type=script&lang=js&"
export * from "./CollaboratorPriceTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports